/**
 * Lazy load menu konta — pobiera właściwą treść (zalogowany/gość) od razu
 * po załadowaniu strony. HTML strony pozostaje anonimowy i jest cache'owany
 * przez Cloudflare, a spersonalizowana zawartość przychodzi przez AJAX.
 */
export function initNavbarAccountLazy() {
  const accountEl = document.querySelector('[data-account-lazy]');
  if (!accountEl || !window.sebaNavbarAjax) return;

  const dropdown = accountEl.querySelector('.navbar-account__dropdown');
  if (!dropdown) return;

  fetch(window.sebaNavbarAjax.ajaxUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: 'action=seba_get_account_menu',
    credentials: 'same-origin',
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.success && data.data && data.data.html) {
        dropdown.innerHTML = data.data.html;
      }
    })
    .catch(() => {});
}
